var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.connected)?_c('div',[_c('h1',[_vm._v("Rapport")]),_c('ReportExport')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }